<template>
    <v-select
        :label="$t(`filters.labels.${name}`)"
        :items="items"
        v-model="model"
        @change="$emit('applyFilter', { name: name, value: model })"
        clearable
    ></v-select>
</template>

<script>
export default {
    props: ['name', 'resource', 'options'],

    data: () => {
        return {
            items: [],
        }
    },

    computed: {
        key() {
            return [this.resource, this.name].join('.')
        },
        model: {
            get() {
                return this.$store.getters['filters/getByDotNotation'](this.key)
            },
            set(value) {
                if (!value) {
                    this.$store.commit('filters/unset', {
                        resource: this.resource,
                        name: this.name,
                    })
                    return
                }
                this.$store.commit('filters/apply', {
                    resource: this.resource,
                    filter: { name: this.name, value: value },
                })
            },
        },
    },

    created() {
        const keys = Object.keys(this.options)
        keys.forEach(key => {
            this.items.push({
                text: this.options[key],
                value: key,
            })
        })
    },
}
</script>

<style></style>
